import { PaginatedResourcesForProductQueryDto, SharedPaginatedResultDto, SharedResourceInfo } from '@bondsports/types';
import { auth } from 'lib/auth';
import { network } from 'lib/network';
import { buildQueryString } from 'lib/urlUtils';
import { DEFAULT_PAGE } from 'types/payment';
import { ResourceInterface } from 'types/resources';

const apiUrl = process.env.BOND_SPORTS_API_URL;

function getProductResources(productId: number, includeResources = false): Promise<ResourceInterface[]> {
	return network.get(
		`${apiUrl}v4/product-pricing/product/${productId}/resources?futureResources=true&${
			includeResources ? 'includeResources=true' : 'includeResources=false'
		}`
	);
}

function getPaginatedProductResources<T>(productId: number, filters: PaginatedResourcesForProductQueryDto): Promise<T> {
	const { headers } = auth.getAuthHeaders();
	const query = buildQueryString(filters);
	return network.get(
		`${apiUrl}v4/product-pricing/product/${productId}/paginated/resources${query}`, { headers }
	);
}

async function getAllResourcePages<T>(
	productId: number,
	filters: PaginatedResourcesForProductQueryDto,
	pageAmount?: number
): Promise<T[]> {
	const promises: Promise<T>[] = [];
	if (!pageAmount) {
		const response: SharedPaginatedResultDto<T, SharedResourceInfo> = await getPaginatedProductResources(productId, filters);
		if (response) {
			pageAmount = response?.meta?.totalPages ?? DEFAULT_PAGE;
		}
	}
	for (let i = 1; i <= (pageAmount ?? DEFAULT_PAGE); i++) {
		const resourcePromise: Promise<T> = getPaginatedProductResources(productId, {
			...filters,
			page: i,
		});
		promises.push(resourcePromise);
	}
	return Promise.all(promises);
}

export const resourceApi = { getAllResourcePages, getProductResources, getPaginatedProductResources };
